module.exports = __webpack_public_path__ + "media/images/thumbs/pathophys/9D1DZEInZu0oUEMaks0GC-e667b92915e7dcfec1bdb2955ddaeabe.jpg";